<form #form="ngForm" (ngSubmit)="save(form)" class="roster-summary-line-form">
  <p-message severity="error" text="{{errorMessage}}" *ngIf="errorMessage"></p-message>
  <div class="p-fluid p-formgrid-del p-grid p-mt-0">
    <div class="p-field p-col-12 p-md-8">
      <span class="p-float-label" title="This roster summary will be displayed in the selected roster project">
        <p-dropdown #rosterProjectDD [options]="rosterProjects"
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputId="rosterProject" 
                    name="rosterProject"
                    optionLabel="title"
                    filter="true"
                    optionValue="id"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="rosterSummaryLine.rosterProjectId"></p-dropdown>
        <label for="rosterProjectDD" class="bold-field blue-field">Roster Project</label>
      </span>
    </div>
    <div class="p-field p-col-12 p-md-4 p-mb-0">
      <span class="p-float-label" title="Only employees within these selected companys will be used in caculation">
        <p-multiSelect [options]="employers" 
                        class="p-inputtext-sm" 
                        name="employers"
                        appendTo="body"
                        [showHeader]="true"
                        [filter]="true"
                        [showToggleAll]="false"
                        inputId="employers" 
                        optionLabel="employerName"
                        dataKey="id"
                        [maxSelectedLabels]="1"                        
                        [(ngModel)]="selectedEmployers">
          <ng-template let-employer pTemplate="item">
            <span *ngIf="!employer.active">(Inactive) </span>
            <span>{{employer.employerName}}</span>
          </ng-template>
        </p-multiSelect>

        <label for="companyCode" class="bold-field blue-field">Company Code</label>
      </span>
    </div>
  </div>

  <div class="p-fluid p-formgrid-del p-grid p-mt-0">
    <div class="p-field p-col-12 p-md-8 p-mb-0">
      <span class="p-float-label" title="Roster summary title displayed at the bottom of the roster">
        <input pInputText 
              id="title" name="title"
              class="p-inputtext-sm"
              [(ngModel)]="rosterSummaryLine.title" />
        <label for="title" class="bold-field blue-field">Title</label>
      </span>
    </div>

    <div class="p-field p-col-12 p-md-2 p-mb-0">
      <span class="p-float-label" title="A numeric value used to determine the display order of summary lines. The lower number will be displayed first.">
        <p-inputNumber  inputId="sortNo" class="p-inputtext-sm"
                        name="sortNo"
                        mode="decimal" 
                        [(ngModel)]="rosterSummaryLine.sortNo"></p-inputNumber>              
        <label for="sortNo" class="bold-field blue-field">Sort No</label>
      </span>
    </div>

    <div class="p-field p-col-12 p-md-2 p-mb-0 p-mt-2">
      <div class="p-field-checkbox" title="Flag used to determine if this summary line should be displayed in the roster or not.">
        <p-checkbox 
              [(ngModel)]="rosterSummaryLine.active" 
              binary="true" 
              inputId="active"               
              name="active"></p-checkbox>
        <label for="active">Active</label>
      </div>
    </div>
  </div>

  <div class="p-fluid p-formgrid-del p-grid p-mt-0">
    <div class="p-field p-col-12 p-md-5">
      <span class="p-float-label" title="Formular used to count employees. [On Site] will count employee if the payroll roster code for that employee on a given day is DS or NS; [Off Site] will count employee if the payroll roster code for that employee a given day is neither DS nor NS; [Roster Code] allows select one or more roster codes and will be counted if an employee’s payroll roster code matches any of the selected roster codes. ">
        <p-dropdown #rosterSummaryFormularDD [options]="rosterSummaryFormulars" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputId="rosterSummaryFormular" 
                    name="rosterSummaryFormular"
                    optionLabel="formularName"
                    dataKey="id"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="rosterSummaryLine.rosterSummaryFormular"></p-dropdown>
        <label for="rosterSummaryFormular" class="bold-field blue-field">Formula used to count employee</label>
      </span>
    </div>

    <div class="p-field p-col-12 p-md-7" *ngIf="showRosterCodeDropdown()">
      <span class="p-float-label" title="Selected roster codes will be used in the [Roster Code] formula">
        <p-multiSelect [options]="rosterCodes" 
                        class="p-inputtext-sm" 
                        name="rosterCodes"
                        appendTo="body"
                        [showHeader]="false"
                        [filter]="false"
                        [showToggleAll]="false"
                        inputId="rosterCode" 
                        optionLabel="code"
                        dataKey="id"
                        [maxSelectedLabels]="1"                        
                        [(ngModel)]="rosterSummaryLine.rosterSummaryFormular.rosterCodes">
        </p-multiSelect>
        <label for="rosterCode" class="bold-field blue-field">Select roster codes</label>
      </span>
    </div>
  </div>

  <div class="p-fluid p-formgrid-del p-grid p-mt-0">
    <div class="p-field p-col-12 p-md-12 p-mb-0" title="Only employees within the selected work groups will be counted by the selected formula.">
      <p-pickList 
                [source]="workGroups" 
                [target]="selectedWorkGroups" 
                sourceHeader="Available Work Groups ({{workGroups.length}})" 
                targetHeader="Selected Work Groups ({{selectedWorkGroups.length}})" 
                [dragdrop]="false"
                [responsive]="true" 
                [sourceStyle]="{'height':'20rem'}" 
                [targetStyle]="{'height':'20rem'}" 
                [showSourceControls]="false"
                [showTargetControls]="false"
                [showSourceFilter]="false"
                [showTargetFilter]="false"
                filterBy="name">
        <ng-template let-workGroup pTemplate="item">
          <div class="item">
            <div class="item-detail">
              <div class="p-mb-3 p-mt-3">
                <i class="fas fa-user-friends fa-lg"></i> <span class="p-ml-3">{{workGroup.name}}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </p-pickList>      
    </div>
  </div> 

  <div class="modal-footer">
    <button pButton pRipple label="Save" class="p-button p-button-raised" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button p-button-raised p-button-outlined" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>